import React, { useContext, useEffect } from "react";
import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import { AppContext } from "context/App";
import { Link, useParams } from "react-router-dom";
import { packClasses } from "Utils";
import { CubeIcon } from "@heroicons/react/outline";
import GeneralPanel from "./Panels/GeneralPanel";
import AccountPanel from "./Panels/AccountPanel";
import SeoPanel from "./Panels/SeoPanel";
import AnfPanel from "./Panels/AnfPanel";
import DocsPanel from "./Panels/DocsPanel";
import GroupsPanel from "./Panels/GroupsPanel";
import WorkflowsPanel from "./Panels/WorkflowsPanel";
import AutomationPanel from "./Panels/AutomationPanel";
import SendPanel from "./Panels/SendPanel";
import SupportPanel from "./Panels/SupportPanel";

export default function SettingsPage(props) {
    const { setCurrentNav } = useContext(AppContext);
    const { setting } = useParams();

    const panels = {
        general: <GeneralPanel />,
        account: <AccountPanel />,
        seo: <SeoPanel />,
        anf: <AnfPanel />,
        documents: <DocsPanel />,
        group: <GroupsPanel />,
        workflows: <WorkflowsPanel />,
        automation: <AutomationPanel />,
        send: <SendPanel />,
        support: <SupportPanel />,
    };

    useEffect(() => {
        setCurrentNav("settings");
    }, [setCurrentNav]);

    /*
general
    personality
    auto logout
    auto save
account
    change password
domain
    show dns settings
    show validator and alias
seo
    default seo settings (from CEO3)

*/
    return (
        <MainBlock>
            <div style={{ minHeight: "75% vh" }}>
                <div className="my-2 flex h-full rounded bg-white shadow-sm">
                    <div className="w-xs max-w-xs divide-y overflow-auto rounded rounded-r-none">
                        <div>
                            <Link
                                to="/app/settings/general"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "general"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>General</strong>
                                <p className="text-xs text-gray-700">
                                    CEO features and interface.
                                </p>
                            </Link>
                        </div>
                        <div>
                            <Link
                                to="/app/settings/account"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "account"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>Account Settings</strong>
                                <p className="text-xs text-gray-700">
                                    Your account and how you interact with CEO.
                                </p>
                            </Link>
                        </div>
                        <div>
                            <Link
                                to="/app/settings/support"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "support"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>Support & Help</strong>
                                <p className="text-xs text-gray-700">
                                    Need help? We're here for you.
                                </p>
                            </Link>
                        </div>
                        <div>
                            <Link
                                to="/app/settings/group"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "group"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>Manage Access</strong>
                                <p className="text-xs text-gray-700">
                                    Update group permissions.
                                </p>
                            </Link>
                        </div>
                        <div>
                            <Link
                                to="/app/settings/send"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "send"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>Send to CEO</strong>
                                <p className="text-xs text-gray-700">
                                    Send your content directly to CEO.
                                </p>
                            </Link>
                        </div>
                        <div>
                            <Link
                                to="/app/settings/workflows"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "workflows"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>Workflows</strong>
                                <p className="text-xs text-gray-700">
                                    Content and assignment workflows
                                </p>
                            </Link>
                        </div>
                        <div>
                            <Link
                                to="/app/settings/automation"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "automation"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>Automation</strong>
                                <p className="text-xs text-gray-700">
                                    Automation settings.
                                </p>
                            </Link>
                        </div>
                        <div>
                            <Link
                                to="/app/settings/seo"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "seo"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>SEO</strong>
                                <p className="text-xs text-gray-700">
                                    Default SEO settings for your public site.
                                </p>
                            </Link>
                        </div>
                        <div>
                            <Link
                                to="/app/settings/anf"
                                className={packClasses(
                                    "block p-4 text-left text-gray-600",
                                    setting && setting === "anf"
                                        ? "bg-gray-50 text-gray-800"
                                        : ""
                                )}
                            >
                                <strong>Apple News</strong>
                                <p className="text-xs text-gray-700">
                                    Connect CEO directly to Apple News
                                </p>
                            </Link>
                        </div>
                    </div>
                    <div className="bg-inherit relative flex flex-grow overflow-auto rounded rounded-l-none border-l border-gray-200">
                        {!setting ? (
                            <div className="flex flex-grow items-center justify-center">
                                <CubeIcon className="inline-block h-10 w-10 text-gray-300" />
                            </div>
                        ) : (
                            <div className="w-full">
                                {setting && panels[setting] ? (
                                    panels[setting]
                                ) : (
                                    <div className="flex flex-grow flex-row overflow-auto p-4">
                                        <div className="text-sm text-gray-600">
                                            This setting panel is currently
                                            unavailable
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </MainBlock>
    );
}
